import CloseIcon from '@mui/icons-material/Close'
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen'
import OpenInFullIcon from '@mui/icons-material/OpenInFull'
import styled from 'styled-components'

import { MOBILE_WIDTH } from 'pared/constants/styles'

export const ChatContainer = styled.div<{
  isExpanded?: boolean
}>`
  position: fixed;
  bottom: 0px;
  right: ${(props) => (props.isExpanded ? '10px' : '40px')};
  transition: right 0.3s ease-in-out;

  @media ${MOBILE_WIDTH} {
    left: auto;
    right: 0;
  }

  @media (max-height: 599px) and (orientation: landscape) {
    left: auto;
    right: 5px;
  }
`

export const ChatButton = styled.button`
  background-color: rgb(59, 59, 59);
  color: #fff;
  border: none;
  font-family: Lexend-SemiBold;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px 10px 0 0;
`

export const ChatButtonTitle = styled.div`
  margin-right: 2px;
`

export const ChatWindow = styled.div<{
  isOpen: boolean
  width?: string
  height?: string
  isExpanded?: boolean
}>`
  width: ${(props) => {
    if (props.isExpanded) return 'calc(100vw - 270px)'
    return props.width || '500px'
  }};
  height: ${(props) => {
    if (!props.isOpen) return '0px'
    if (props.isExpanded) return 'calc(100vh - 100px)'
    return props.height || '800px'
  }};
  background-color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  border-radius: 10px 10px 0 0;
  overflow: hidden;
  transition: all 0.3s ease-in-out;

  @media ${MOBILE_WIDTH} {
    width: 100vw !important;
    left: 0;
    right: 0;
    border-radius: 0;
    max-width: 100vw;
    height: ${(props) => {
      if (!props.isOpen) return '0px'
      if (props.isExpanded) return 'calc(100vh - 40px)'
      return props.height || '85vh'
    }};
  }

  @media (max-height: 599px) and (orientation: landscape) {
    width: 90vw !important;
    left: 0;
    right: 0;
    border-radius: 0;
    max-width: 90vw;
    height: ${(props) => {
      if (!props.isOpen) return '0px'
      if (props.isExpanded) return '50vw'
      return props.height || '40vw'
    }} !important;
    max-height: 50vw !important;
  }
`

export const ChatHeader = styled.div`
  background-color: rgb(59, 59, 59);
  color: #fff;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  font-family: Lexend-SemiBold;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
`

export const ChatIcon = styled.img`
  width: 30px;
  height: 30px;
  margin: 4px 8px 4px 2px;
`

export const StyledIconButton = styled(CloseIcon)`
  color: #fff;
`

export const StyledExpandIcon = styled(OpenInFullIcon)`
  color: #fff;
  cursor: pointer;
`

export const StyledShrinkIcon = styled(CloseFullscreenIcon)`
  color: #fff;
  cursor: pointer;
`

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ChatIframe = styled.iframe`
  width: 100%;
  height: 95%;
  border: none;
`

export const ChatButtonContainer = styled.div<{
  isOpen: boolean
}>`
  display: ${(props) => (!props.isOpen ? 'flex' : 'none')};
  justify-content: space-between;
`
